/* =======================================================
   MR. STABBY — AVAILABILITY
   This is the file you edit to control what dates clients
   can book. The booking form reads it automatically.
   ======================================================= */

/* Days you tattoo. 0=Sun 1=Mon 2=Tue 3=Wed 4=Thu 5=Fri 6=Sat */
var WORK_DAYS = [0, 1, 5];          // Sunday, Monday, Friday

/* How many weeks ahead to offer */
var WEEKS_AHEAD = 8;

/* BOOKED / blocked dates — when you take a booking, add the date
   here and it instantly disappears from the form for everyone.
   Format: 'YYYY-MM-DD'  (one per line, comma separated) */
var BOOKED_DATES = [
  '2026-06-26',   // example — Fri 26 Jun (taken)
  '2026-06-29'    // example — Mon 29 Jun (taken)
];
